/**
 * @param {string} path
 * @param {string} prefix
 */
function removeProjectPrefix (path, prefix) {
  if (!path || !prefix) return path

  // Only remove prefix from routes and not files
  const extensions = /\.(?:css|ttf|woff|woff2|svg|png|jpg|jpeg|js)$/i
  if (!extensions.test(path)) {
    const regex = new RegExp(`${prefix}/`, 'g')
    path = path.replace(regex, '')
  }

  return path
}

module.exports = { removeProjectPrefix }
